import React from 'react';
import EditorTemplate from './Editor/EditorTemplate';
import {PanelTemplateSelected} from './DashBoard/PanelTemplateSelected';
import newInstanceI18next from '../../../Util/traductionUtils.js';
import { I18nextProvider } from 'react-i18next';
import {NavFormat} from './NavFormat';
import {IframeContainer} from './Editor/IframeContainer';
import {MenuList} from '../../Menu/MenuItem';
import {useCatalogueEditorContext} from './Context/CatalogueContextProvider';
import { useTranslation } from 'react-i18next';
import styles from './CatalogueContainer.module.css';
import {
	iconLight,
	iconCustomTemplate,
	iconTemplate
} from '../../../Components/CustomIcon/CustomIcon';
import SectionMessage from '../../../Components/SectionMessage';
import Btn from '../../../Components/Btn';
export default function CatalogueContainer() {
	return (
		<I18nextProvider i18n={newInstanceI18next}>
			<CatalogueContainerInner />
		</I18nextProvider>
	);
}


function CatalogueContainerInner() {

	const [t] = useTranslation('inspiration');
	const {
		mode,
		handleSelectMode,
		objectivesForMenu,
		setPanelIsOpen,
		canViewRealizations,
		canViewReadyTemplates,
		canViewCustomTemplates,
		$rootScope
	} = useCatalogueEditorContext();

	const handleObjectifClick = (objId) => {
		const el = document.querySelector('.js-catalog-group-' + objId);
		if (el) el.scrollIntoView({ behavior: 'smooth'});
		setPanelIsOpen(false);
	};

	const handleReadyClick = (newMode) => {
		const el = document.querySelector('.js-catalog-view');
		if (el) el.scrollTo({top: 0, behavior: 'smooth'});
		handleSelectMode(newMode);
		setPanelIsOpen(false);
	};

	const objectivesForList = objectivesForMenu.map((o) => {
		return {
			label: t('objectives.' + o.id + '.label'),
			onClick: () => handleObjectifClick(o.id),
			isDisabled: o.nbItems === 0
		};
	});

	const menuItems:any[] = [];

	if (canViewReadyTemplates) {
		menuItems.push({
			label: t('templateLibrary'),
			onClick: () => handleReadyClick('templates'),
			isActive: mode === 'templates',
			customIcon: iconTemplate,
			items: objectivesForList,
			isControlled: true,
			skeletonNumber: 6
		});
	}

	if (canViewCustomTemplates) {
		menuItems.push({
			label: t('myCustomTemplates'),
			onClick: () => handleSelectMode('custom'),
			isActive: mode === 'custom',
			customIcon: iconCustomTemplate
		});
		// menuItems.push({
		// 	label: t('styleLibrary'),
		// 	onClick: () => handleReadyClick('library'),
		// 	isActive: mode === 'library',
		// 	customIcon: iconPerformance,
		// 	items: objectivesForList,
		// 	isControlled: true
		// });
	}

	if (canViewRealizations) {
		menuItems.push({
			label: t('realizations'),
			onClick: () => handleSelectMode('realizations'),
			isActive: mode === 'realizations',
			customIcon: iconLight
		});
	}

	function openIntercom() {
		// @ts-ignore
		const ic = window.Intercom;
		if (!ic) return;
		ic('showNewMessage');
	}

	return (
		<>
			<div className={[styles.sidebar, 'vscroll'].join(' ')}>
				<div className={styles.sidebar_body}>
					<MenuList items={menuItems} />
				</div>
				<div className={styles.sidebar_footer}>
					<SectionMessage
						appearance="background_outline"
						showIcon={false}
						noMargin={true}
						type="information"
						title={'The old version is going away soon'}
						fontSize="s"
						text={
							<p>
								You can still switch back for now, but starting <strong className='fw_medium'>22 July</strong>,
								only the new Inspiration library will be available.
							</p>
						}
						buttons={
							<>
								<Btn
									size="s"
									style="link"
									message="Back to old version"
									onClick={() => {
										localStorage.setItem('inspiration-version', 'old');
										$rootScope.$broadcast('event:changeStateOfInspirationPanel', true);
										$rootScope.$broadcast('event:changeStateOfCataloguePanel', false);
									}}
								/>
								<span className='dot'></span>
								<Btn
									size="s"
									style="link"
									message="Feedback"
									onClick={openIntercom}
								/>
							</>
						}
					/>
				</div>
			</div>
			<div className={styles.main}>
				<div className={[styles.view, 'vscroll', 'js-catalog-view'].join(' ')}>
					<NavFormat />
					{(canViewCustomTemplates || canViewReadyTemplates) &&
						<EditorTemplate />
					}
					{canViewRealizations &&
						<IframeContainer src={'https://catalogue.beyable.com/'} />
					}
				</div>
				<PanelTemplateSelected />
			</div>
		</>
	);
}



